exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard___3Bvk4{width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"dashboard": "dashboard___3Bvk4"
};